export default "__VITE_ASSET__BV_Kmn2U__"